import {action, computed, observable, makeObservable, runInAction} from 'mobx';
import {enumToValues} from '@netx/core-next/utils/enum';
import {keywordIncludeContentsEnabled} from '@netx/core-search-next/enablers';
import {RuleModel} from '../baseModel';
import {KeywordType, SearchTypeKeyword, TSearchTypeKeyword} from './constants';
import {keywordRuleDefaults} from './defaults';
import type {KeywordRule} from './types';
import {validateKeywordRule} from './validate';

export class KeywordRuleModel
	extends RuleModel<TSearchTypeKeyword>
	implements KeywordRule
{
	readonly elementType = SearchTypeKeyword;

	elementSubType1: KeywordType = keywordRuleDefaults.elementSubType1;
	elementSubType2: 0 = keywordRuleDefaults.elementSubType2;
	elementValue1 = keywordRuleDefaults.elementValue1;
	elementValue2: '' | 'true' = keywordIncludeContentsEnabled()
		? 'true'
		: keywordRuleDefaults.elementValue2;
	elementValue3: '' = keywordRuleDefaults.elementValue3;

	get elementSubType1Options() {
		return enumToValues(KeywordType);
	}

	get isValid() {
		const validation = validateKeywordRule(this);
		this.setValidationErrors(this.dirty && validation ? validation : undefined);
		if (!validation) return true;
		return false;
	}

	constructor(params?: Partial<Omit<KeywordRule, 'elementType'>>) {
		super();

		runInAction(() => {
			Object.assign(this, params);
		});

		makeObservable(this, {
			elementSubType1: observable,
			elementSubType1Options: computed,
			elementValue1: observable,
			elementValue2: observable,
			isValid: computed,
			setElementSubType1: action,
			setElementValue1: action,
			setElementValue2: action,
		});
	}

	setElementSubType1(elementSubType1: KeywordType) {
		this.elementSubType1 = elementSubType1;
	}

	/** stubbed */
	setElementSubType2() {}

	/**
	 * Set keywords
	 * @param elementValue1 keywords
	 */
	setElementValue1(elementValue1: string) {
		this.elementValue1 = elementValue1;
		this.dirty = true;
	}

	/**
	 * Set if we should include contents
	 * @param elementValue2 inlcude contents
	 */
	setElementValue2(elementValue2: '' | 'true') {
		this.elementValue2 = elementValue2 as this['elementValue2'];
	}

	/** stubbed */
	setElementValue3() {}
}

export default KeywordRuleModel;
